module.exports = __webpack_public_path__ + "images/bannerDE-2fa5ae3bbfd4b6434005d64fa29da26c.png";